import { Fragment, useEffect, useState } from "react";
import { AntInput } from "../../antinput";
import { ChatState } from "../../../../base/models/model";
import { CoreServices } from "../../../../base/service/apiServices";
import { GetItemFromStorage } from "../../../../custom_hooks/useStorage";
import { LocalStorage } from "../../../../custom_hooks/localStorageKeys";
import { getAllUsers } from "../../../../store/api/user_management";
import styles from "./vmAgentTransfer.module.scss";
import { useDispatcher } from "../../../../custom_hooks/use_app_dispatch";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { videoCallService } from "./../../../../base/service/videoCallService";
import store from "../../../../store/redux-store/root_store";
import { meetActionTypes } from "../../../../base/action/action";
import { stopScreenSharing } from "../../../../base/video_common";


function VmAgentTransfer() {
  const [agentList, setAgentList] = useState<any>([]);

  const agentUserList: any = useSelector((state: any) => state.userList);
  const { users } = agentUserList;
  const userDetails = GetItemFromStorage(LocalStorage.USER_DETAILS);
  const LoginUserDetails: any = userDetails;
  const chatReducer: ChatState = useSelector((state: any) => state.chatReducer);
  const dispatch = useDispatcher();
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(getAllUsers());
  }, [dispatch]);

  useEffect(()=>{
    setAgentList(users);
  },[users]);

  const closeAgentList=()=>{
    let {vm_acd_event}:any=store.getState().meetingReducer;
    store.dispatch({
      type:meetActionTypes.VM_TRANSFER,
      payload:{
        vmTransfer:false,
        vm_acd_event:vm_acd_event,
        vmTransferDropdown:false,
        vmTransferDetails:{}
      }
    })
  }

  const makeVideoCall = (user: any) => {
    let {currdeviceinfo}:any=store.getState().meetingReducer;
    const sharingReducerState:any=store.getState().sharingReducerState;
    if(currdeviceinfo.recordingStatus !=="stop"){videoCallService.recordingAction("stop", currdeviceinfo.conId);}
    if(sharingReducerState.sharingStatus){stopScreenSharing();}
    let data:any={
      "emailId":user.emailId,
      "UserID":user.UserID,
      "ext":user.ext,
      "roleid":user.roleid,
      "UserName":user.UserName
    }
    store.dispatch({
      type:meetActionTypes.VM_TRANSFER,
      payload:{
        vmTransfer:false,
        vm_acd_event:0,
        vmTransferDropdown:false,
        vmTransferDetails:data
      }
    })
      if(currdeviceinfo.recordingStatus !=="stop"){setTimeout(()=>{
        videoCallService.sendTransferDetails(data);
      },3000)}
      else{
        videoCallService.sendTransferDetails(data);
      }
      closeAgentList();
  };

  const getAgentList = async(e: any) => {
    if (e?.target?.value?.trim() !== "") {
      await CoreServices.get(`/get_all_user_list?name=${e.target.value}`).then((value) => {
        //setAgentList(value.data.getAllUserList);
        const _users = value.data.getAllUserList.filter((el:any)=>{return el.UserName.toLowerCase().includes(e?.target?.value?.trim().toLowerCase())});
        setAgentList(_users);
      });
    } else {
      //setAgentList(allContactList);
      setAgentList(users);
    }
  };

  const agentsWithVoice = [] as any;


  agentList.forEach((user: { chat: any; voice: any; socialMedia: any; }) => {
    if (user.voice) agentsWithVoice.push(user);
  });

  return (
    <>
      <div className={`${styles.callcontainartopsec}`}>
        <AntInput className="transferSearch transfersearchinput" onChange={getAgentList} placeHolder="Search" />
        <div className={styles.agentsList}>
        {agentList.length === 0
            ? "No data" : agentsWithVoice.map((data: any, idx: any) => {
              if (
                ['3', '5', '6'].includes(`${data.roleid}`) &&
                parseInt(data.ext) !== parseInt(LoginUserDetails?.ext)
              ) {
                return (
                  <Fragment key={idx}>
                    {
                      // data?.statusName === "Ready" || data?.statusName === "Transfer Only" ? (
                      (data?.isVoiceCallTransfer_AgentStatus === 1 || data?.isVoice === 1) ? (
                        <div className={`${styles.users}`} onClick={() => makeVideoCall(data)}>
                          <div className={styles.callStatus}>
                            <div className={styles.ready}></div>
                          </div>
                          <div className={styles.userDetails}>
                            <span className={styles.agentName}>{data?.UserName}</span>
                            <span className={styles.agentNumber}>{data?.statusName}</span>
                          </div>
                        </div>
                      ) : (  // : data?.status === 'busy' ?
                        <div className={`${styles.users} ${styles.onHold}`}>
                          <div className={styles.callStatus}>
                            <div
                              className={
                                data?.statusName == "Offline"
                                  ? styles.offLine
                                  : data?.statusName == "Away"
                                    ? styles.busy
                                    : data?.statusName == "Not Ready"
                                      ? styles.busy
                                      : styles.busy
                              }
                            ></div>
                          </div>
                          <div className={styles.userDetails}>
                            <span className={styles.agentName}>{data?.UserName}</span>
                            <span className={styles.agentNumber}>{data?.statusName}</span>
                          </div>
                        </div>
                      )
                    }
                  </Fragment>
                );
              }
            })
          }
        </div>
      </div>
    </>
  );
}

export default VmAgentTransfer;
